import Util from "./Util";
import { BASE_URIS, ID_SPACE, TPIS_PARAMS } from "../components/domain/constants";
import { isNotABlankString } from "./StringUtil";

/**
 * Specifically looks up the type and title of the program. This is essentially for use only in the Upload page, where
 * the merlinId and adiId are passed if needed, and the other fields have to be looked up in order to fill entityInfo
 */
export function lookupForType(instance, merlinId, adiId) {
  if (merlinId != null || adiId != null) {
    let canLookUp = false;
    let entityProvider, entityId;
    if (isNotABlankString(merlinId)) {
      canLookUp = true;
      entityProvider = ID_SPACE.MERLIN;
      entityId = merlinId;
    } else if (isNotABlankString(adiId)) {
      canLookUp = true;
      entityProvider = ID_SPACE.ADI;
      entityId = adiId;
    }
    if (canLookUp === true) {
      if (entityProvider == null) {
        if (isNaN(entityId)) {
          entityProvider = ID_SPACE.ADI;
        } else {
          entityProvider = ID_SPACE.MERLIN;
        }
      }
      const uri = makeUri(entityProvider, entityId);
      Util.fetchWithRedirect(uri, 'GET', instance.props).then(resp => {
        if (resp.error != null) {
          Util.openSnackbar('Entity info lookup was not successful. Some fields may display as \'N/A\'', instance.snackbar);
        } else {
          instance.setState({
            type: resp.type,
            entityTitle: resp.title,
            subtitle: "Episode" === resp.type ? resp.episodeTitle : "SportingEvent" === resp.type ? resp.sportsSubtitle : null
          });
        }
      });
    }
  } else {
    instance.setState({
      type: null,
      entityTitle: null,
      entityId: null,
      entityProvider: null
    });
  }
}
function makeUri(entityProvider, entityId) {
  return "".concat(BASE_URIS.prefix).concat(BASE_URIS.lookup) + "?".concat(TPIS_PARAMS.PROVIDER, "=").concat(entityProvider) + "&".concat(TPIS_PARAMS.ENTITY_ID, "=").concat(entityId);
}
export function fillInEntityInfo(instance) {
  let canLookUp = false;
  if (isNotABlankString(instance.state.entityId)) {
    if (instance.state.entityProvider == null || instance.state.entityProvider !== ID_SPACE.MERLIN) {
      instance.state.adiId = instance.state.entityId;
      canLookUp = true;
    } else {
      instance.state.merlinId = instance.state.entityId;
      canLookUp = true;
    }
  } else {
    if (isNotABlankString(instance.state.adiId)) {
      instance.state.entityId = instance.state.adiId;
      instance.state.entityProvider = ID_SPACE.ADI;
      canLookUp = true;
    } else if (isNotABlankString(instance.state.merlinId)) {
      instance.state.entityId = instance.state.merlinId;
      instance.state.entityProvider = ID_SPACE.MERLIN;
      canLookUp = true;
    }
  }
  if (canLookUp === true) {
    const uri = makeUri(instance.state.entityProvider, instance.state.entityId);
    Util.fetchWithRedirect(uri, 'GET', instance.props).then(resp => {
      if (resp.error != null) {
        Util.openSnackbar('Entity info lookup was not successful. Some fields may display as \'N/A\'', instance.snackbar);
      } else {
        let respAdiId = findIdInResponse(null, resp);
        let respMerlinId = findIdInResponse(ID_SPACE.MERLIN, resp);
        if (respMerlinId == null && resp.merlinId != null) respMerlinId = resp.merlinId;
        const type = resp.type;
        instance.setState({
          title: resp.title,
          adiId: respAdiId,
          merlinId: respMerlinId,
          subtitle: "Episode" === type ? resp.episodeTitle : "SportingEvent" === type ? resp.sportsSubtitle : null,
          type: type,
          lookupComplete: true
        });
      }
    }).catch(err => {
      Util.log('APIUtil.fillInEntityInfo', true, err, false);
    });
  }
}
export function loadDisplayInfo(instance) {
  const uri = BASE_URIS.prefix + BASE_URIS.displayInfo;
  Util.fetchWithRedirect(uri, 'GET', instance.props).then(resp => {
    if (resp.error != null) {
      Util.openSnackbar('Unable to look up display info. Sorts and filters may not be successful', instance.snackbar);
    } else {
      instance.setState({
        allFilters: resp.filters,
        allSortFields: resp.sorts,
        messageTypes: resp.entityMessageTypes
      });
    }
  }).catch(err => {
    Util.log('APIUtil.loadDisplayInfo', true, err, false);
  });
}
function findIdInResponse(idSpace, response) {
  const additionalIds = response.additionalIds;
  if (additionalIds == null) {
    return null;
  }
  for (let id of additionalIds) {
    if (idSpace != null && id.entityProvider === idSpace || idSpace == null && id.entityProvider !== ID_SPACE.MERLIN) {
      return id.entityId;
    }
  }
  return null;
}